__turbopack_context__.v({
  "spin": "Toast-module-scss-module__hPMZxq__spin",
  "toast": "Toast-module-scss-module__hPMZxq__toast",
  "toast-container": "Toast-module-scss-module__hPMZxq__toast-container",
  "toast__button": "Toast-module-scss-module__hPMZxq__toast__button",
  "toast__icon": "Toast-module-scss-module__hPMZxq__toast__icon",
  "toast__icon__state-progress": "Toast-module-scss-module__hPMZxq__toast__icon__state-progress",
});
